import prd from './config.prd';
import dev from './config.dev';

const actualEnv = process.env.NODE_ENV === 'production' // eslint-disable-line no-undef
  ? prd : dev;

export default actualEnv;